var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "issue"
  }, [_c('ul', {
    staticClass: "protocolList"
  }, _vm._l(_vm.experimentList, function (experiment, idx) {
    return _c('li', {
      key: idx,
      staticClass: "protocolItem"
    }, [_c('div', {
      staticClass: "info",
      attrs: {
        "data-grid": "info"
      }
    }, [_c('p', {
      staticClass: "title",
      attrs: {
        "data-grid": "title"
      }
    }, [_vm._v(" " + _vm._s(experiment.experimentName) + " ")]), _c('p', {
      staticClass: "user"
    }, [_c('span', [_vm._v("공유여부 : " + _vm._s(experiment.experimentType == 'DEFAULT' || experiment.experimentType == 'RELEASE' ? '공정도기본' : experiment.experimentType == 'SHARE' ? '공유O' : '공유X'))]), _vm._v("| "), _c('span', [_vm._v("작성자 : " + _vm._s(experiment.user.name))])])]), _c('div', {
      staticClass: "link",
      attrs: {
        "data-grid": "link"
      }
    }, [_c('button', {
      on: {
        "click": function ($event) {
          return _vm.updateExperimentType(experiment.experimentId);
        }
      }
    }, [_vm._v("상세보기")]), _vm.getExperimentResultMode == 'edit' && _vm.$route.query.menuType == 'researcher' ? _c('button', {
      on: {
        "click": function ($event) {
          return _vm.copyExperimentType(experiment.experimentId);
        }
      }
    }, [_vm._v("복사")]) : _vm._e(), _vm.getExperimentResultMode == 'edit' && experiment.experimentType != 'DEFAULT' && experiment.experimentType != 'RELEASE' && (experiment.experimentType == 'SHARE' && _vm.user.id == experiment.userId || _vm.user.committee || experiment.experimentType == 'CUSTOM' && _vm.user.id == experiment.userId || _vm.user.committee) ? _c('button', {
      on: {
        "click": function ($event) {
          return _vm.deleteExperimentType(experiment.experimentId);
        }
      }
    }, [_vm._v("삭제 ")]) : _vm._e()])]);
  }), 0)]);

}
var staticRenderFns = []

export { render, staticRenderFns }